export default "__VITE_ASSET__0a36a331__"